module.exports = __webpack_public_path__ + "img/hamburger-menu.a01c8ef7.svg";